export const translateError = e => {
    const errors = {
        "Email address is already in use.": "E-Mail bereits verwendet",
        "IBAN already used": "IBAN bereits verwendet",
        "Incorrect username or password. Please try again.": "Falscher Benutzername oder falsches Passwort. Bitte versuche es erneut.",
        "Die E-Mail-Adresse wird bereits verwendet.": "Diese E-Mail wird bereits verwendet",
        "Error uploading receipt": "Ne pare rau, dar fisierul incarcat nu seamana cu un bon fiscal sau factura. Te rugam sa incerci cu o alta poza/imagine.",
        "Incorrect Code": "Codul nu este valid.",
        "Recaptcha token is required.": "Vă rugăm să finalizați verificarea recaptcha",
        "Recaptcha token is invalid.": "Indicatorul recaptcha este nevalid",
        "Campaign not found": "Campania nu a fost găsită"
    }
    return errors[e] || e;
}

export let myHistory = [];

export default {
    methods: {
        goToPage: (pageName, self) => {
            const showNavLinks = !self.$store.getters.excludedPages.includes(pageName);
            self.$store.commit('setShowNavLinks', showNavLinks);
            // self.$emit
            // console.log("gotopage::->", pageName)
            self.$eventHub.$emit('goToPage-event', pageName);

            // change url when moving to another page
            if (location.pathname.slice(1) !== pageName) {
                if (!self.skipPushState) {
                    myHistory.push(location.pathname.slice(1) || 'home');
                }

                history.replaceState(myHistory, null, '/' + pageName)
            }
        },
        sendProductPhotos: (params, buttonComponent) => {
            let fieldId = params;
            // console.log("1. will SEND products:::", fieldId, buttonComponent)

            buttonComponent.loading = true;
            buttonComponent.$eventHub.$on('done-event-trigger',
                (parent) => buttonComponent.doneTrigger(buttonComponent, parent));

            buttonComponent.$eventHub.$emit('sendProductPhotos-event', fieldId);
        },
        sendForm: (params, buttonComponent) => {
            if (params.indexOf(',') > -1) {
                params = params.split(',')
            }
            let formId = params;
            let neuStarTrigger = false
            if (self._.isArray(params)) {
                formId = params[0]
                neuStarTrigger = params.filter(param => param === 'neuStarTrigger')
                // console.log("1. will SEND FORM:::", formId, 'neuStarTrigger', neuStarTrigger.length > 0)
            }
            const triggers = {
                neuStarTrigger: neuStarTrigger.length > 0
            }
            // console.log("1. will SEND FORM:::", formId, "NO TRIGGER")
            buttonComponent.loading = true;
            buttonComponent.$eventHub.$on('done-event-trigger',
                (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
            // console.log("2. will SEND FORM:::", formId, buttonComponent)

            buttonComponent.$eventHub.$emit('getFormData-event', formId, triggers);
        },
        sendProducts: (formId, buttonComponent) => {
            // console.log("SEND PRODUCTS:::", formId)
            buttonComponent.loading = true;
            buttonComponent.$eventHub.$on('done-event-trigger',
                (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
            buttonComponent.$eventHub.$emit('sendProducts-event', formId);
        },
        getCustomerToken: (params, self) => {
            // console.log("getCustomerToken", self)
            self.$store.dispatch('retrieveUserToken')
        },
        doneTrigger: (component, eventResult) => {
            component.$eventHub.$off('done-event-trigger');
            component.loading = false
            // console.log('1. will Done Trigger', eventResult)
            // console.log('event Result',eventResult)
            // if (eventResult.status) {
            //     eventResult.parent.clear()
            // }
            if (!eventResult.status && eventResult.message) {
                // console.log("EVENT RESULT>>>", eventResult)
                // const lang = "de"

                // Oops. Something went wrong, please try again later.
                // const defaultErrorMessage = "Hoppla. Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut."
                // if (eventResult.invalid_fields && eventResult.invalid_fields.length) {
                //     const localErr = translateErrpr(eventResult.invalid_fields[0], lang)
                //     if (localErr) component.showModal(localErr)
                //     else component.showModal(defaultErrorMessage)
                //     return
                // }
                component.showModal(eventResult.message)
            }

        },
        sendReceipt: (component, buttonComponent) => {
            buttonComponent.loading = true;
            buttonComponent.$eventHub.$on('done-event-trigger',
                (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
            buttonComponent.$eventHub.$emit('sendReceipt-event')
        },
        showModal: (message, self) => {
            self.$store.commit('setModalOptions', { isActive: true, message })
        }
    }
}
